import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'link-audio-note',
  templateUrl: './link-audio-note.component.html',
  styleUrls: ['./link-audio-note.component.scss']
})
export class LinkAudioNoteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
